"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CascaderMenuBox = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var dropdown_1 = require("../../dropdown");
var util_1 = require("../../util");
var CascaderMenuLists_1 = require("./CascaderMenuLists");
var CascaderMultiMenuLists_1 = require("./CascaderMultiMenuLists");
function CascaderMenuBox(_a) {
    var multiple = _a.multiple, className = _a.className, style = _a.style, props = tslib_1.__rest(_a, ["multiple", "className", "style"]);
    var classPrefix = util_1.useConfig().classPrefix;
    return (react_1.default.createElement(dropdown_1.DropdownBox, { className: classnames_1.default(className, "size-auto-width"), style: style },
        react_1.default.createElement("div", { className: classPrefix + "-cascader-menu " + classPrefix + "-cascader-menu--thin" }, multiple ? (react_1.default.createElement(CascaderMultiMenuLists_1.CascaderMultiMenuLists, tslib_1.__assign({}, props))) : (react_1.default.createElement(CascaderMenuLists_1.CascaderMenuLists, tslib_1.__assign({}, props))))));
}
exports.CascaderMenuBox = CascaderMenuBox;
CascaderMenuBox.displayName = "CascaderMenuBox";
//# sourceMappingURL=CascaderMenuBox.js.map